import { render, staticRenderFns } from "./reprintDialog2.vue?vue&type=template&id=37f9c5d4&scoped=true&"
import script from "./reprintDialog2.vue?vue&type=script&lang=js&"
export * from "./reprintDialog2.vue?vue&type=script&lang=js&"
import style0 from "./reprintDialog2.vue?vue&type=style&index=0&id=37f9c5d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9c5d4",
  null
  
)

export default component.exports